import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { UserManagementService } from 'src/app/services/user-management.service';

@Component({
    selector: 'app-select-branch',
    templateUrl: './select-branch.component.html',
    styleUrls: ['./select-branch.component.scss'],
    standalone: false
})
export class SelectBranchComponent implements OnInit {
  @Output() OnBranchChangeData: EventEmitter<any> = new EventEmitter<[]>();

  branchData: any;
  selectedBranch: any;
  selectedState: any;
  stateData: any;
  userData: any;
  userBranches: any;
  userId: string;

  constructor(private userDashboardService: UserDashboardService, private storageService: StorageService , private userManagementService:UserManagementService, private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.userId = this.storageService.getUserID() || null;

    // Load states and user details in parallel, then auto-populate branch
    const states$ = this.userDashboardService.getStates();
    const user$ = this.userId
      ? this.userManagementService.getUsersDetailsById(this.userId)
      : null;

    if (user$) {
      forkJoin({ states: states$, user: user$ }).subscribe(({ states, user }: any) => {
        this.stateData = states['content'];
        this.userData = user['content'][0];
        this.userBranches = this.userData.branches;

        this.selectedState = this.storageService.getState() || null;
        this.cdr.detectChanges();

        if (this.selectedState !== null) {
          this.getBranchData();
        }
      });
    } else {
      // Fallback: no userId, just load states
      states$.subscribe((res: any) => {
        this.stateData = res['content'];
        this.selectedState = this.storageService.getState() || null;
        this.cdr.detectChanges();
        if (this.selectedState !== null) {
          this.getBranchData();
        }
      });
    }
  }

  getUserDetails(id) {
    this.userManagementService.getUsersDetailsById(id).subscribe((res: any) => {
      this.userData = res['content'][0];
      this.userBranches = this.userData.branches;
    });
  }

  getState() {
    this.userDashboardService.getStates().subscribe((res: any) => {
      this.stateData = res['content'];
      this.selectedState = this.storageService.getState() || null;
      this.cdr.detectChanges();
      if (this.selectedState !== null) {
        this.getBranchData();
      }
    });
  }

  getBranchData() {
    this.branchData = [];
    const account_id = this.storageService.getAccountId() || null;

    this.userDashboardService.getBranchListbyStateId(this.selectedState.id, account_id).subscribe((res: any) => {
      let branches = res['content'];
      branches = branches.filter((element: any) => element.is_active === true);

      // Only filter by userBranches if the list is available
      if (this.userBranches && this.userBranches.length > 0) {
        branches = branches.filter((branch: any) => this.userBranches.includes(branch.id));
      }

      this.branchData = branches;

      // Restore the previously selected branch from storage
      const savedBranch = this.storageService.getBranch() || null;
      if (savedBranch) {
        // Match by id so the dropdown object reference aligns with branchData
        this.selectedBranch = this.branchData.find((b: any) => b.id === savedBranch.id) || savedBranch;
      } else {
        this.selectedBranch = null;
      }

      this.cdr.detectChanges();
    });
  }

  onBranchSelect() {
    this.storageService.setBranch(this.selectedBranch);
    this.storageService.branchChange.next(this.selectedBranch); // Emit the branch change event
    this.OnBranchChangeData.emit(this.selectedBranch);
  }

  onStateChange() {
    this.selectedBranch = null; // Clear branch when state changes
    this.getBranchData();
    this.storageService.setState(this.selectedState);
    this.storageService.stateChange.next(this.selectedState); // Emit the state change event
  }
}